<template>
    <div class="card">
        <Toast />
        <ConfirmDialog/>
        <div class = "button-row">
            <Button label="조회" icon="pi pi-search" class="p-button-success mr-2" @click="btnAct('SEARCH')" />
            <Button label="저장" icon="pi pi-save" class="p-button-success mr-2" @click="btnAct('SAVE')" :disabled="!selectedItems || !selectedItems.length" />
            <Button label="엑셀" icon="pi pi-download" class="mr-2" @click="downloadExcel($event)" />
            <Button label="CSV" icon="pi pi-download" class="mr-2" @click="exportCSV($event)" />
        </div>
        <Toolbar>
            <template #start>
                <div class="grid">
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="publicId" v-model="searchParams.publicId" :options ="publicCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                @change="changePublicId" :disabled="isCustUser" scrollHeight="20em" :editable="true" />
                        <label for="publicId">업체소재지</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="corpId" v-model="searchParams.corpId" :options ="corpCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"
                                :disabled="isCustUser" scrollHeight="20em" :editable="true"/>
                        <label for="corpId">업체명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="pgmId" v-model="searchParams.pgmId" :options ="pgmCodes" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 11rem"/>
                        <label for="pgmId">프로그램명</label>
                    </div>
                    <div class="p-field p-float-label m-2">
                        <Dropdown id="modChk" v-model="searchParams.modChk" :options ="modChks" optionLabel="codeNm" optionValue="code" :showClear="true" style="width: 9rem"/>
                        <label for="modChk">수정체크권한</label>
                    </div>
                </div> 
            </template>

            <template #end>
                
            </template>
        </Toolbar>

        <!-- <DataTable id="dt" ref="dt" :value="dataList" rowGroupMode="subheader" groupRowsBy="publicNm" :loading="loading"
            v-model:selection="selectedItems" class="editable-cells-table p-datatable-sm virtualscroll" bodyStyle="height: 84vh"
            editMode="cell" @cell-edit-init="onCellEditInit" @cell-edit-complete="onCellEditComplete" 
            sortMode="single" sortField="publicNm" :sortOrder="1" scrollHeight="79vh"> -->

        <DataTable id="dt" ref="dt" :value="dataList" v-model:selection="selectedItems" showGridlines 
            rowIndexVar="rowIndex" :loading="loading"
            editMode="cell" @cell-edit-complete="onCellEditComplete" class="editable-cells-table p-datatable-sm" 
            :scrollable="true" scrollHeight="79vh" responsiveLayout="scroll">

            <Column header="No" style="min-width:3em; max-width:3em" exportFooter=" ">
                <template #body="{index}">
                    {{ index + 1 }}
                </template>    
            </Column>
            <Column selectionMode="multiple" style="min-width:3em; max-width:3em" :exportable="false" exportFooter=" "></Column>
            <Column field="publicNm" header="관할행정" exportFooter=" "></Column>
            <Column field="corpId" header="업체코드" exportFooter=" "></Column>
            <Column field="corpNm" header="업체명" exportFooter=" "></Column>
            <Column field="pgmId" header="프로그램명" exportFooter=" ">
                <template #body="{data}">
                    {{(pgmCodes.find(e=>e.code == data.pgmId)||{codeNm:""})['codeNm']}}
                </template>
            </Column>
            <Column field="modChk" header="수정체크권한" style="min-width:8em; max-width:8em" exportFooter=" ">
                <template #body="{data, field}">
                    <Checkbox v-model="data[field]" :binary="true" @click="onClickCheckbox(data, field)"/>
                </template>
                <!-- <template #editor="{ data, field }">
                    <Checkbox name="modChk" :value="data.modChk" v-model="data[field]" :binary="true"/>
                </template> -->
            </Column>
            <Column field="register" header="자료업로드기준일자" style="min-width:10em; max-width:10em" exportFooter=" ">
                <template #body="{ data, field }">
                    {{ convertDateString(data[field]) }}
                </template>
                <template #editor="{ data, field }">
                    <Calendar v-model="data[field]"  :monthNavigator="true" :yearNavigator="true" yearRange="2010:2099" showButtonBar :showIcon="true" style="width: 9rem"/>
                </template>
            </Column>
            <template #groupheader="slotProps">
                <span class="image-text">{{slotProps.data.publicNm}}</span>
            </template>
            <template #groupfooter="slotProps">
                <td style="min-width: 100%">
                    <div style="text-align: right; width: 100%">소계 ({{ calculateTotalCnt(slotProps.data.publicNm) }}건)</div>
                </td>
            </template>
        </DataTable>
    </div>
</template>

<script>
import { ref, onMounted, reactive } from 'vue';
import { useToast } from 'primevue/usetoast';
import { useConfirm } from 'primevue/useconfirm';
import CodeService from '@/service/cm/CodeService';
import CustService from '@/service/ma/CustService';
import MA201040Service from '@/service/ma/MA201040Service';
import JsUtils from '@/utilities/JsUtils';

export default {
    setup() { 
        onMounted(() => {
            // 로그인한 사용자 정보를 얻어온다
            var user = JSON.parse(localStorage.getItem("user"));
            if(user != null && user.username != null) {
                searchParams.compSeq = user.compSeq;    // 법인코드
                if(user.publicId != null && user.publicId != '' && (user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr')) {
                    searchParams.publicId = user.publicId;  // 업체소재지

                    // 업체 목록을 얻어온다
                    custService.getCodeList(searchParams).then(data => {
                        corpCodes.value = data;
                        // 업체 목록에서 사용자가 속한 업체를 선택된 상태로 만든다
                        searchParams.corpId = user.custSeq;
                         if(user.userGbCd != null) {
                            // 업체사용자 또는 업체관리자인 경우, 자신이 속한 업체만 볼수 있게 한다
                            if(user.userGbCd == 'cu_user' || user.userGbCd == 'cu_mngr') {
                                isCustUser.value = true;    
                            }
                            // 시군구담당자인 경우
                            if(user.userGbCd == 'ct_mngr') {
                                searchParams.ctrPublicId = user.publicId;
                            }
                        }  
                    });
                }
            }

            // 검색조건에 시작일자,종료일자를 표시한다
            let date = new Date();  
            let fromDate = new Date(date.getFullYear(), date.getMonth(), 1);  // 당월 첫째 일자
            searchParams.fromDate = JsUtils.getDateString(fromDate);            
            searchParams.toDate = JsUtils.getDateString(new Date());          // 현재 일자

			codeService.getCodeList({ compSeq:1, upCode:'_public_id'}).then(data=> publicCodes.value = data);  // 관할행정지역 코드
            codeService.getTableCodeList({ sqlId:'pgmlist_code', compSeq:1}).then(data => pgmCodes.value = data);  // 일지코드관리 코드
        })
		const codeService = new CodeService();
        const custService = new CustService();
        const ma201040Service = new MA201040Service();
        const searchParams = reactive({publicId:null,corpId:null,pgmId:null,modChk: null});
        const dataList = ref([]);
        const selectedItems = ref([]);
        const publicCodes = ref([]);
        const corpCodes = ref([]);
        const pgmCodes = ref([]);
        const modChks = ref([
            {codeNm: 'Y', code: 'Y'},
            {codeNm: 'N', code: 'N'}
        ]);
        const confirm = useConfirm();
        const toast = useToast();
        const loading = ref(false);
        // 액셀출력
        const dt = ref(); // 데이터 데이블  ref 
        const isCustUser = ref(false); // 업체사용자 여부 

        const btnAct = (_act) =>
        {
            switch(_act)
            {
                case "SEARCH":
                    searchList();
                    break;
                case "SAVE":
                    saveList();
                    break;                    
                default:
            }
        }

        const searchList = () => {
            searchParams.fromDate = JsUtils.convertDateToString(searchParams.fromDate);
            searchParams.toDate = JsUtils.convertDateToString(searchParams.toDate);

            loading.value = true;
            ma201040Service.getList(searchParams).then(data => {    
                if (data.length == 0) toast.add({severity:'warn', summary:'조회 결과', detail:'조회 결과가 없습니다.', life:2000});               
                dataList.value = data;
                
                dataList.value.forEach(row => {
                    row.modChk = row.modChk == 1 ? true : false;
                });

            }).finally(() => {
                loading.value = false;
            });
        };

        const saveList = () => {
            confirm.require({
                message:'선택된 항목(들)을 저장하시겠습니까?',
                header: '저장',
                icon: 'pi pi-exclamation-triangle',
                accept: () => {
                    selectedItems.value.forEach(row => {
                        row.modChk = row.modChk == true ? 'Y' : 'N';    // Checkbox는 true or fale 값을 가지므로 Y' or 'N'으로 변환한다

                        if(row.register != null && row.register != undefined) {
                            row.register = row.register.replace(/-/gi, "");  // 날짜형식을  'yyyy-mm-dd' 형식을 'yyyymmdd'으로 변경한다
                        }
                        else {
                            row.register = "00000000";
                        }
                    });

                    ma201040Service.updateList(selectedItems.value).then(() => {
                        // Datatable에서 선택된 행들을 초기화 한다
                        selectedItems.value = [];
                        searchList();
                        toast.add({severity:'success', summary: '완료', detail: '저장 완료', life: 3000});
                    })
                    .catch(error => {
                        if (error.response) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.response.data.message, life: 3000});
                        } else if (error.request) {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.request.data, life: 3000});	
                        } else {
                            toast.add({severity:'error', summary: '저장 오류', detail: error.message, life: 3000});	
                        }
                    });
                },
                reject: () => {
                    toast.add({severity:'error', summary:'취소', life: 3000});
                }
            });
        };

        const changePublicId= () => {
            // 현재 선택된 업체소재지로 업체 목록을 가져와서 업체명 Dropdown 목록에 표시한다
            if(searchParams.publicId != null) {
                custService.getCodeList(searchParams).then(data => {
                    corpCodes.value = data;
                });
            }
            else {
                corpCodes.value = [];
            }
            searchParams.corpId = null;
        }

        const convertDateString = (data) => {
            return JsUtils.convertDateString(data);
        }

        const calculateTotalCnt = (name) => {
            let total = 0;

            if (dataList.value) {
                for (let data of dataList.value) {
                    if (data.publicNm === name) {
                        total++;
                    }
                }
            }

            return formatToPrice(total);
        };

        // 셀 편집 시작 시, Datatable의 해당 행(Row)를 선택된 상태로 만든다
        const onCellEditInit = (event) => {
            let { data, field } = event;
            let _ = require('lodash');

            switch (field) {
                case "modChk": {
                    // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
                    const _row = _.find(selectedItems.value, {'corpId': data.corpId, 'pgmId': data.pgmId});

                    if(_row == null || _row == undefined) {
                        selectedItems.value.push(data);
                    }
                    break;
                }
                case "register": {
                    data[field] = JsUtils.convertDateString(data[field]);   // yyyymmdd 형식을 yyyy-mm-dd 형식으로 표시한다
                    break;
                }
                default:
                    break;
            }

        };
        
        const onClickCheckbox = (data, field) => {
            switch (field) {
                case "modChk": {
                    data[field] = !data[field];
                    break;
                }
                default:
                    break;
            }
             // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용 예) corpId, lineId
            const _ = require('lodash');
            let _row = _.find(selectedItems.value, function(obj) {
                if (obj.rowNo === data.rowNo) {
                    return true;
                }
            });

            if(_row == null || _row == undefined) {
                selectedItems.value.push(data);
                if(data.rowNo != null && data.rowNo !="신규") {
                    data.rowNo = '수정';
                }
            }
        };

        // 셀 편집 후, Datatable의 해당 행(Row)를 선택된 상태로 만든다
        const onCellEditComplete = (event) => {
            let { data, newValue, field } = event;
            if(data[field] === newValue) return;

            switch (field) {
                case "register": {  // 자료업로드 기준일자
                    if(newValue == null) {
                        data[field] = "00000000";
                    }
                    else {
                        data[field] = JsUtils.convertDateToString(newValue);    // yyyymmdd 형식을 yyyy-mm-dd 형식으로 표시한다
                    }
                    break;
                }
                default:
                    break;
            }

            // 기존에 추가된 행이 아닌 경우에만 선택된 행 목록에 추가한다
            // 해당 Row를 유일하게 구분할 수 있는 값 사용 예) corpId, lineId
            const _ = require('lodash');
            let _row = _.find(selectedItems.value, function(obj) {
                if (obj.rowNo === data.rowNo) {
                    return true;
                }
            });

            if(_row == null || _row == undefined) {
                selectedItems.value.push(data);
                if(data.rowNo != null && data.rowNo !="신규") {
                    data.rowNo = '수정';
                }
            }

        };

        // 천단위마다 콤마(,) 표시를 한다
        const formatToPrice = (value) => {
           var num = Number(value).toFixed(0);
          return `${Number(num).toLocaleString()}`; // "ko-KR"
        }

        // 액셀 다운로드
        const downloadExcel = () => {
            // datatable(즉, users.value)에 있는 모든 항목들을 엑셀 파일로 다운로드 한다 - 컬럼명이 필드(영문)으로 나옴
            //JsUtils.downloadExcel(users.value);

            // table의 html 내용을 그대로 엑셀 파일로 다운로드 한다 - paging 사용 시 해당 한 페이지만 다운로드 됨
            JsUtils.downloadExcel2('dt');  // id='dt'
        }

        // CSV 다운로드
        const exportCSV = () => { 
            dt.value.exportCSV();   // dt는 ref="dt"
        };

        return { 
            dt, searchParams, dataList, publicCodes, selectedItems, loading, isCustUser, 
            modChks, corpCodes, pgmCodes, formatToPrice, convertDateString, calculateTotalCnt, 
            btnAct, saveList, downloadExcel, exportCSV, changePublicId, onCellEditInit, onCellEditComplete, onClickCheckbox
        }

    }
}
</script>

<style lang="scss" scoped>
.p-rowgroup-footer td {
    font-weight: 700;
}

::v-deep(.p-rowgroup-header) {
    span {
        font-weight: 700;
    }

    .p-row-toggler {
        vertical-align: middle;
        margin-right: .25rem;
    }
}

/*
::v-deep(.editable-cells-table td.p-cell-editing) {
    padding-top: 0;
    padding-bottom: 0;
}
*/

.table-header {
    display: flex;
    align-items : center;
    justify-content: space-between;

    @media screen and (max-width: 960px) {
        align-items: start;
	}
}
b{
    font-size: 30px;
}

.user-image {
    width: 50px;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .user-image {
    width: 50px;
    margin: 0 auto 2rem auto;
    display: block;
}

.confirmation-content {
    display: flex;
    justify-content: center;
}
@media screen and (max-width: 960px) {
	::v-deep(.p-toolbar) {
		flex-wrap: wrap;
        
		.p-button {
            margin-bottom: 0.25rem;
        }
	}
}
</style>
